/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";

const VerticalNumberField = props => {
  const { input, label, placeholder, type, meta: { touched, error }, min } = props;
  const invalid = touched && error ? "invalid" : "";
  return (
    <div className="form-group">
      <label htmlFor={input.name}>{label}</label>
      <input
        {...input}
        type={type}
        placeholder={placeholder}
        className={`form-control ${invalid}`}
        min={min}
      />
    </div>
  );
};
VerticalNumberField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.boolean,
    error: PropTypes.string
  }).isRequired,
  min: PropTypes.number
};
VerticalNumberField.defaultProps = {
  min: 0
};

export default VerticalNumberField;



// WEBPACK FOOTER //
// ./src/forms/fields/VerticalNumberField.js